"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderReviewNotificationService = void 0;
class OrderReviewNotificationService {
    static getByOrderId(orderId) {
        const fromStorage = window.sessionStorage.getItem(this.storageKeyByOrderId(orderId));
        if (!fromStorage) {
            return null;
        }
        return this.parseFromStorage(fromStorage);
    }
    static getLastSkipDate() {
        const fromStorage = window.sessionStorage.getItem(this.storageKey);
        if (!fromStorage) {
            return null;
        }
        const date = new Date(fromStorage);
        if (isNaN(date.getTime())) {
            return null;
        }
        return this.parseFromStorage(fromStorage);
    }
    static saveSkipDate() {
        window.sessionStorage.setItem(this.storageKey, new Date().toISOString());
    }
    static saveSkipDateByOrderId(orderId) {
        window.sessionStorage.setItem(this.storageKeyByOrderId(orderId), new Date().toISOString());
    }
    static shouldRequestReview() {
        const lastSkipDate = this.getLastSkipDate();
        if (lastSkipDate) {
            const currentDate = new Date();
            const diffBetweenTodayAndLastReview = currentDate.getTime() - lastSkipDate.getTime();
            const T24_HOURS = 1000 * 60 * 60 * 24;
            if (diffBetweenTodayAndLastReview < T24_HOURS) {
                return false;
            }
        }
        return true;
    }
    static parseFromStorage(fromStorage) {
        if (!fromStorage) {
            return null;
        }
        const date = new Date(fromStorage);
        if (isNaN(date.getTime())) {
            return null;
        }
        return date;
    }
}
exports.OrderReviewNotificationService = OrderReviewNotificationService;
OrderReviewNotificationService.storageKey = 'customer-order-review-skip-timestamp';
OrderReviewNotificationService.storageKeyByOrderId = (orderId) => `customer-review-skip-timestamp-${orderId}`;
